import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/vue-query";
import axios from "axios";
import {
  MePreferenceEventsApi,
  type MePreferenceEventsApiV2MePreferencesEventsGetRequest,
  Sorting,
} from "mws-ts-v2-sdk";

let mePreferenceEventsApi: MePreferenceEventsApi;

const getMePreferenceEventsApi = () => {
  if (!mePreferenceEventsApi)
    mePreferenceEventsApi = new MePreferenceEventsApi(
      undefined,
      useRuntimeConfig().public.catalogServiceUrl,
      axios,
    );

  return mePreferenceEventsApi;
};

const getEventPreferences = (
  params: MePreferenceEventsApiV2MePreferencesEventsGetRequest,
) =>
  getMePreferenceEventsApi().v2MePreferencesEventsGet({
    ...params,
    sortBy: params?.sortBy ?? Sorting.Descending,
    sort: params?.sort ?? "EndDate",
  });

export const followedEventsListQueryKeys = createQueryKeys("followedEvents", {
  list: (
    params: MaybeRef<MePreferenceEventsApiV2MePreferencesEventsGetRequest>,
  ) => ({
    queryKey: [params],
    queryFn: async () => {
      const response = await getEventPreferences(unref(params));

      return response.data;
    },
  }),
});

export const useFollowedEventsQuery = () => {
  const platformStore = usePlatformStore();
  const platformId = computed(
    () => platformStore.getPlatformConfiguration.platformId,
  );

  const params = computed(() => ({
    pageSize: 1000,
    followed: true,
    sortBy: Sorting.Ascending,
    xPlatformKey: platformId.value,
  }));

  return useQuery({
    ...followedEventsListQueryKeys.list(params),
    refetchInterval: 60000,
  });
};
